import React from 'react';
import { RouteObject } from 'react-router-dom';
import { AdminRoot, AdminOverviewPage } from 'pages';
import { AdminRouteList } from 'types';
import { CampaignList } from 'pages/Admin/CampaignList/CampaignList';
import { UsersList } from 'pages/Admin/UsersList/UsersList';
import { InvoiceList } from '../pages/Admin/InvoiceList/InvoiceList';

export const adminRoutes: RouteObject[] = [
  {
    element: <AdminRoot />,
    children: [
      {
        element: <AdminOverviewPage />,
        path: AdminRouteList.Overview,
        children: [
          {
            element: <CampaignList />,
            path: AdminRouteList.Campaigns,
          },
          {
            element: <UsersList />,
            path: AdminRouteList.Users,
          },
          {
            element: <InvoiceList />,
            path: AdminRouteList.Invoices,
          },
        ],
      },
    ],
  },
];
